export const checkBoxFilters = ['dealer'];
export const rangeFilters = ['createdAt'];
export const radioFilters = ['page', 'sortBy'];
